import { render, staticRenderFns } from "./item_v1.vue?vue&type=template&id=3e14a8d4&scoped=true"
import script from "./item_v1.vue?vue&type=script&lang=js"
export * from "./item_v1.vue?vue&type=script&lang=js"
import style0 from "./item_v1.vue?vue&type=style&index=0&id=3e14a8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e14a8d4",
  null
  
)

export default component.exports